import React from 'react';

import { Link } from 'react-router-dom';
import './Services.css';

const servicesData = [
    {
        icon: '🔍',
        title: 'SEO Optimization',
        description: 'Dominate search results with our proven SEO strategies. We optimize your website for maximum visibility and organic traffic growth.',
        link: '/services/seo'
    },
    {
        icon: '📈',
        title: 'PPC & Google Ads',
        description: 'Get instant visibility with targeted advertising campaigns. We manage your ad spend to maximize conversions and ROI.',
        link: '/services/paid-ads'
    },
    {
        icon: '💻',
        title: 'Web Development',
        description: 'High-performance websites built for conversions. From design to development, we create digital experiences that drive results.',
        link: '/services/web-development'
    },
    // {
    //     icon: '📱',
    //     title: 'Social Media Marketing',
    //     description: 'Build your brand and engage your audience across all social platforms with strategic content and campaigns.',
    //     link: '/services/paid-ads'
    // },
    {
        icon: '✉️',
        title: 'Email Marketing',
        description: 'Nurture leads and drive conversions with personalized email campaigns that deliver the right message at the right time.',
        link: '/services/email-marketing'
    },
    {
        icon: '📊',
        title: 'Analytics & Reporting',
        description: 'Data-driven insights to optimize your marketing performance. Track, measure, and improve every aspect of your campaigns.',
        link: '/services/gohighlevel'
    }
];

const Services = () => {
    return (
        <section className="services" id="services">

            <div className="container">
                <div className="label">Our Services</div>
                <h2>Comprehensive Digital Marketing Solutions</h2>
                <p className="services-subtitle">We help businesses grow with data-driven strategies and cutting-edge digital marketing solutions</p>
                <div className="services-grid">
                    {servicesData.map((service, index) => (
                        <Link to={service.link} className="service-card" key={index}>
                            <div className="service-icon">{service.icon}</div>
                            <h3>{service.title}</h3>
                            <p>{service.description}</p>
                            <div className="service-arrow">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </Link>
                    ))}
                </div>
                <div className="services-cta">
                    <Link to="/services" className="btn btn-primary">
                        View All Services
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Services;
